import {Component, Input, OnInit} from '@angular/core';
import {NgIf, NgOptimizedImage} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {IconComponent} from '../../../../../../shared/components/icons-svgs/icons-svgs.component';

@Component({
  selector: 'app-template-error',
  standalone: true,
  imports: [
    NgIf,
    NgOptimizedImage,
    TranslateModule,
    IconComponent
  ],
  templateUrl: './template-error.component.html',
  styleUrl: './template-error.component.scss'
})
export class TemplateErrorComponent implements OnInit{
  @Input() public locale: string = 'en';
  public contactFormUrl: string;
  public imgAltText: string = 'Illustration of the contact page';

  ngOnInit(): void {
    if (this.locale !== 'en') {
      this.imgAltText = 'Illustration de la page contact du partenaire';
    }
    this.setContactFormUrl();
  }

  public setContactFormUrl(): void {
    this.contactFormUrl = 'https://form.typeform.com/to/Skse0ywG';
    if (this.locale === 'fr') {
      this.contactFormUrl = 'https://form.typeform.com/to/vfP7UpuV';
    }
  }
}
